import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { BotaoChatComponent } from '../../components/botao-chat/botao-chat.component';
import { BreadcrumbComponent } from '../../components/breadcrumb/breadcrumb.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { CurrencyPipe } from '@angular/common';
import { CnpjPipe } from '../../pipes/cnpj.pipe';
import { AppDatePipe } from '../../pipes/app-date.pipe';

@Component({
    selector: 'app-resumo-pedido-processado',
    templateUrl: './resumo-pedido-processado.component.html',
    styleUrls: ['./resumo-pedido-processado.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, BotaoChatComponent, BreadcrumbComponent, RouterLink, FooterComponent, CurrencyPipe, CnpjPipe, AppDatePipe]
})
export class ResumoPedidoProcessadoComponent implements OnInit {
  detalhesPedido: any;
  isPrePago: any;

  constructor(private readonly router: Router) {
    const pedido = this.router.currentNavigation().extras.state?.pedido;
    if (pedido !== undefined) {
      this.detalhesPedido = JSON.parse(pedido);
      this.isPrePago = this.router.currentNavigation().extras.state?.isPrePago;
    }
  }

  ngOnInit(): void {
    if (!this.detalhesPedido) {
      this.router.navigate(['/home']);
    }
  }
}
